export function TextMetric(props: { text: string }) {
  return (
    <div style={{ textAlign: "center", fontWeight: 400, fontSize: 20 }}>
      {props.text}
    </div>
  );
}
